<template>
    <div id="HVUTScheduleList">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Asset FHUT List</div>
                    <div class="web-action-btn">
                        <!-- Button for Clear Cache -->
                        <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                        <div class="btn-groups text-right">
                            <button v-if="canProcessHvut" v-on:click.prevent="openProcessModal" class="btn btn-secondary"> <i class="fp-process"> </i> Process /  Unpost</button>
                            <a v-if="addHvut" href="javascript:void(0)" class="btn btn-primary" v-on:click="updateHvutAsset">
                                <i class="fp-reload"></i> Update New FHUT Asset
                            </a>
                            <a v-if="addHvut" href="javascript:void(0)" class="btn btn-primary" v-on:click="addHvutAsset">
                                <i class="fp-add"></i> Add New Asset To FHUT
                            </a>
                        </div>
                    </div>
                    <div class="mobile-action-btn elipse-btn">
                        <button v-on:click.prevent="openProcessModal" class="btn btn-secondary"> <i class="fp-process"> </i> Process</button>
                        <button type="button" class="btn btn-elipse" data-toggle="dropdown" data-toggle-position="left" aria-expanded="false" v-on:click.prevent="myFunction">
                            <i class="fp-ellipsis-v"></i>
                        </button>
                        <div id="myDropdown" class="dropdown-content">
                            <ul>
                                <li>
                                    <a href="javascript:void(0)" class="" v-on:click="updateHvutAsset">Update New FHUT Asset</a>
                                </li>
                                <li>
                                    <a  href="javascript:void(0)" class="" v-on:click="addHvutAsset">Add New Asset To FHUT</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content hvut-schedule-list">
                        <div class="btn-groups badge-buttons text-left mb-3">
                            <div id="divTabMenu" class="btn-group rental-btn-grup-left" role="group" aria-label="Basic example">
                                <button type="button" id="getallFHUTList" v-on:click="getAllFHUTList(this)" :class="'btn btn-secondary '+all"> All </button>
                                <button type="button" id="getentryFHUTList" v-on:click="getEntryFHUTList(this)" :class="'btn btn-secondary '+entry"> Entry </button>
                                <button type="button" id="getprocessedFHUTList" v-on:click="getProcessedFHUTList(this)" :class="'btn btn-secondary '+processed"> Processed </button>
                                <button type="button" id="getexpiredFHUTList" v-on:click="getExpiredFHUTList(this)" :class="'btn btn-secondary '+expired"> Expired </button>
                            </div>
                        </div>
                        <data-table-filter-config :moduleName="'assetHVUTList'" ref="assetHVUTList" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <p v-if="fhutProcessBatch" id="processfhutMsg" class="alert-success p-2">Current batch {{fhutBatchNum}} is processing. Please wait while we process FHUT !!</p>
                        <p v-if="batchError" class="alert-danger p-2" id="fhutErrorBatchMsg">{{batchErrorMsg}}<button type="button" class="close close-alert" v-on:click="batchError = false;batchErrorMsg = ''">×</button></p>
                        <section class="bg-white data-table">
                            <custom-pagination
                                :page-changed="onPageChange"
                                :per-page-changed="onPerPageChange" :moduleName="'assetHVUTList'" :position="'top'">
                            </custom-pagination>

                                <vue-good-table
                                    ref="listHVUTTable"
                                    mode="remote"
                                    title="FHUT"
                                    @on-row-click="onRowClick"
                                    @on-page-change="onPageChange"
                                    @on-selected-rows-change="selectionChanged"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    :totalRows="totalRecords"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                                    :select-options="{
                                    enabled: false,
                                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                    selectionInfoClass: 'custom-class',
                                    selectionText: 'rows selected',
                                    clearSelectionText: 'clear',
                                    }"
                                    :search-options="{
                                    enabled: false,
                                    }">
                                    <div slot="selected-row-actions">
                                        <!-- <template  v-for="(permission, index) in permissions">
                                            <button v-bind:key="'delete'+index" v-if="permission.name == 'delete_asset_type'" id="deleteVehicleTypeBtn" v-on:click.prevent="VehicleHvutDelete" class="btn btn-success waves-effect">Delete</button>
                                        </template> -->
                                    </div>
                        </vue-good-table>
                        <custom-pagination
                            :page-changed="onPageChange"
                            :per-page-changed="onPerPageChange">
                        </custom-pagination>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
        <div class="modal fade add-extra-charge-popup" id="processHvutModal" ref="processHvutModal" data-backdrop="static" data-keyboard="false" aria-labelledby="processHvutModal" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="myModal1">Process FHUT</h5>
                    </div>
                    <div class="modal-body">
                        <form id="SelectDates" class="addinspectionForm">
                            <div class="form-row row-cols-md-1 row-cols-1">
                            <!-- New Change-->
                            <div class="col form-group">
                                <label class="control-label permit-label require">Process Date</label>
                                <v-select v-model="effective_date" name="effective_date" placeholder="Select Date."
                                    label="text"
                                    :options="dateArr">
                                </v-select>
                                <div class="field-error">{{effective_date_error_msg}}</div>
                            </div>
                            <div class="col form-group">
                                <div class="custom-checkbox">
                                    <label class="checkbox-custom">  Generate Invoice <input type="checkbox" v-model="invoice_required" id="invoice_required" name="invoice_required" :disabled="true">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                            </div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-primary" id="addprocessHvutBtn" v-on:click="processHvut(false)">
                            <i class="fp-submit"></i> Process
                        </button>
                      <button v-if="canUnpost" class="btn btn-primary" id="addprocessHvutBtn" v-on:click="processHvut(true)">
                        <i class="fp-submit"></i> Unpost
                      </button>
                        <button type="button" class="btn btn-tertiary" id="cancelprocessHvutBtnBtn" v-on:click="hideProcessModal()">
                            <i class="fp-close"></i> Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

    import Vue from "vue";
    import EventBus from ".././event-bus";

    
    



    import {commonMixins} from '../../mixins/commonMixins';
    import {dataTableMixins} from '../../mixins/dataTableMixins';
    import moment from 'moment';
    let msgServer;

    export default {
        name: "HVUTScheduleList",
        metaInfo: {
            // title will be injected into parent titleTemplate
            title: "Asset FHUT List | " +process.env.COPYRIGHT_NAME
        },
        mixins:[commonMixins,dataTableMixins],
        props: {
            permitValue: {
                type: String,
                required: false,
                default:undefined
            }
        },
        data: () => ({
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            userColumns:[],
            columns: [
                {
                    label: 'Company',
                    field: 'company',
                    fpFieldType:"text",
                    hidden:false,
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Company", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                },
                {
                    label: 'Year',
                    field: 'year',
                    hidden:false,
                    fpFieldType:"text",
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Year", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                },
                {
                    label: 'Unit Number',
                    field: 'unit_no',
                    hidden:false,
                    fpFieldType:"text",
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Unit Number", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                },
                {
                    label: 'Date In Service',
                    field: 'date_in_service',
                    hidden:false,
                    fpFieldType:"date",
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Date In Service", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    sortable:true
                },
                {
                    label: 'Start Date',
                    field: 'start_date',
                    hidden:false,
                    fpFieldType:"date",
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Start Date", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                },
                {
                    label: 'End Date',
                    field: 'end_date',
                    hidden:false,
                    fpFieldType:"date",
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "End Date", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                },
                {
                    label: 'Cost',
                    field: 'cost',
                    fpFieldType:"integer",
                    hidden:false,
                    type:'number',
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Cost", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                },
                {
                    label: 'Allowance',
                    field: 'allowance',
                    fpFieldType:"integer",
                    hidden:false,
                    type:'number',
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Allowance", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                },
                {
                    label: 'Customer',
                    field: 'customer',
                    hidden:false,
                    filterable: true,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "customer", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                },
                {
                    label: 'Location',
                    field: 'location',
                    fpFieldType:"option",
                    hidden:false,
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Location", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                },

                {
                    label: 'FHUT Category',
                    field: 'hvut_category',
                    fpFieldType:"option",
                    hidden:false,
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "FHUT Category", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                },
                {
                    label: 'Gross Weight',
                    field: 'gvw',
                    hidden:false,
                    fpFieldType:"integer",
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Gross Weight", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                },
                {
                    label: 'Status',
                    field: 'status',
                    hidden:false,
                    fpFieldType:"option",
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Status", // placeholder for filter input
                        filterDropdownItems: ['Entry','Processed'],
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                // {
                //     label: 'Actions',
                //     field: 'action',
                //     sortable: false,
                // },
            ],
            rows: [],
            totalRecords: 0,
            asset_value: false,
            loading:false,
            hvut_value:false,
            addHvut:false,
            assetId:"",
            selectedFile:"",
            optionsDate: {
                format: 'MM/DD/YYYY',
                useCurrent: false,
                maxDate:new Date,
                toolbarPlacement:'bottom',
                widgetPositioning: {
                horizontal: 'auto',
                vertical: 'bottom'
                },
            },
            effective_date:'',
            effective_date_error_msg:'',
            invoice_required:true,
            duplicatePermit:[],
            reqeustSent:0,
            pageKey:"_hvut_list_",
            dateArr:[],
            canProcessHvut:false,
            batchError:false,
            batchErrorMsg:"",
            fhutProcessBatch:false,
            fhutBatchNum:"",
            fhutBatchId:0,
            canUnpost: false,
            all: '',
            entry: '',
            processed: '',
            expired: '',
            selectedStatus: '',
        }),
        watch: {
            //check permission change
            permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_hvut_schedule') {
                            self.cantAccessPage = true;
                        } else if (permissions[i].name == 'add_hvut_schedule') {
                            self.addHvut = true;
                        } else if (permissions[i].name == 'delete_hvut_schedule') {
                            self.hvut_value = true;
                        } else if (permissions[i].name == 'process_hvut') {
                            self.canProcessHvut = true;
                        }else if (permissions[i].name == 'unpost_gl') {
                          self.canUnpost = true;
                        }

                    }
                }

            }
        },
        created: function() {
          $(document).on("click", ".generate-invoice-link", (elm) => {
              elm.preventDefault();
              var id = $(elm.target).attr("data-row-id");
              if ( id != undefined && id != null ) {
                  this.$router.push({ name: 'HvutInvoiceCreate', query: { hvut_id : id }});
              }
          });

          //show invoice link if invoice already generated
          $(document).on("click", ".show-invoice-link", (elm) => {
              elm.preventDefault();
              var id = $(elm.target).attr("data-row-invoice-id");
              if ( id != undefined && id != null ) {
                  // self.$router.push({ name: 'HvutInvoice', params:{id: id}});
                  let routeData = this.$router.resolve({ name:"HvutInvoice",params:{ id: id}});
                  window.open(routeData.href,"_blank");
              }
          });
        },
        beforeDestroy(){
            this.$root.$off('load_permit');
        },
        mounted: function() {
            var self = this;
            //when component list directly call from url instead of in view page than call permission request
            self.getPermissions();
            self.getLastDateofmonth();

            $("#divTabMenu button").removeClass("active");
            var prevSelectedTab = localStorage.getItem("fhut_schedule_list_tab");
            console.log('prevSelectedTab:', prevSelectedTab)
            if ( prevSelectedTab == null || prevSelectedTab == 'all_tab') {
                self.selectedStatus = "all";
                self.all = 'active';
                localStorage.setItem('fhut_schedule_list_tab', 'all_tab');
                $("#getallFHUTList").addClass("active");

            } else if( prevSelectedTab == 'entry_tab' ) {
                self.selectedStatus = "entry";
                self.entry = 'active';
                localStorage.setItem('fhut_schedule_list_tab', 'entry_tab');
                $("#getentryFHUTList").addClass("active");
            } else if ( prevSelectedTab == 'processed_tab' ){
                self.selectedStatus = "processed";
                self.processed = 'active';
                localStorage.setItem('fhut_schedule_list_tab', 'processed_tab');
                $("#getprocessedFHUTList").addClass("active");
            } else if ( prevSelectedTab == 'expired_tab' ){
                self.selectedStatus = "expired";
                self.expired = 'active';
                localStorage.setItem('fhut_schedule_list_tab', 'expired_tab');
                $("#getexpiredFHUTList").addClass("active");
            }
        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listHVUTTable.unselectAllInternal();
            },

            selectionChanged(param) {
                    var self = this;
                    if(param.selectedRows.length == 100) {
                      EventBus.$emit('clear-selection', false);
                    } else {
                      EventBus.$emit('clear-all-flags', false);
                    }
                    // console.log(self.computed.selectedRows);
                    // var rowData = self.$refs['my-table'].selectedRows;
                    // console.log(rowData);
                },

            loadList() {
                //remove row of details if any open
                $('table tr.invoiceDetails').remove();

                var self = this;

                if( self.permitValue == 'dontLoadList' ){
                    return;
                }

                    self.loading = true;
                    var fields = {
                        page: self.serverParams.page,
                        perPage: self.serverParams.perPage,
                        filters: self.serverParams.columnFilters,
                        vehicle_id: self.assetId,
                        sort: self.serverParams.sort,
                        selectedStatus: self.selectedStatus,
                        // exportFiltered: self.exportFilteredFlag
                    };
                    self.firstLoad = 1;
                    $.ajax({
                        url: process.env.ROOT_API + "/hvut-schedule/list",
                        type: "POST",
                        data: fields,
                        headers: this.ajxHeaders,
                        dataType: "json",
                        success: function (data) {
                            self.loading = false;
                            if (data.status == 'success') {
                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                                self.filteredFlag = false;
                                if (data.content.batchId != undefined && data.content.batchId != null){
                                    self.fhutProcessBatch = true;
                                    self.fhutBatchId = data.content.batchId;
                                    self.fhutBatchNum = data.content.batch;
                                    self.checkBatchStatus();
                                }
                            }
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            self.generateStatusCodeMessage(jqXHR,false,'load-hvut-scdu-list')
                        }
                    });
            },

            openModal: function(){
                var self = this;
                console.log(self.selectedFile);
                self.selectedFile = "";
                self.duplicatePermit = [];
                $("#typeImage").val('');
                $('#myModal').modal('show');
            },

            openProcessModal: function(){
                var self = this;

                self.effective_date = '';
                self.invoice_required = true;
                $("#processHvutModal").modal('show');
            },
            hideProcessModal(){
                var self = this;
                self.effective_date = '';
                self.effective_date_error_msg = '';
                self.invoice_required = true;
                $("#processHvutModal").modal('hide');
            },
            addHvutAsset:  function(){

                var self = this;
                /*self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/hvut/add",
                    type: "POST",
                    headers: this.ajxHeaders,
                    crossDomain: true,
                    processData: false,
                    contentType: false,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if (data.status == "success") {
                            // self.loadList();
                            self.$router.push('/fhut-schedule/new');
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'add-hvut-scdu-asset')
                    }
                });*/
                self.$router.push('/fhut-schedule/new');
            },
            updateHvutAsset: function(){
                var self = this;

                self.$router.push({ name: 'UpdateHvutAssetSchedule', params: { flag : "update" }});

            },
            processHvut: function(isUnpost){
                var self = this;
                self.effective_date_error_msg = '';

                if ( self.effective_date == ''){
                    self.effective_date_error_msg = 'Process Date Required.';
                    return;
                }

                $("#addprocessHvutBtn").val("Processing ...");
                $("#addprocessHvutBtn").prop("disabled", true);

                $.ajax({
                    url: process.env.ROOT_API + "/hvut/process",
                    type: "POST",
                    data: {
                    // fields:this.$refs['listPermitTable'].selectedRows,
                        effective_date:self.effective_date,
                        invoice_required:self.invoice_required,
                        isReverse:isUnpost
                    },
                    headers: this.ajxHeaders,
                    dataType: 'json',
                    success: function (data) {
                        self.loading = false;
                        // setTimeout(function () {
                        // $(".alert-success").removeClass("show");
                        //     $(".alert-success").addClass("hide");
                        // }, 10000);
                        // setTimeout(function () {
                        //     $("#deleteVehicleTypeBtn").val("Delete");
                        // }, 10000);

                        if (data.code == '200') {
                            $("#processHvutModal").modal('hide');
                            if (data.content.batch != undefined && data.content.batch != "") {
                                if (data.content.batch_id != undefined && data.content.batch_id != null && data.content.batch_id != "") {
                                    self.fhutProcessBatch = true;
                                    self.fhutBatchId = data.content.batch_id;
                                    self.fhutBatchNum = data.content.batch;
                                    self.checkBatchStatus();
                                }
                            }
                            // self.loadList();
                        }
                        $("#addprocessHvutBtn").val("Process");
                        $("#addprocessHvutBtn").prop("disabled", false);
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'process-hvut-scdu')
                    }
                });
            },
            onRowClick(params) {
                var self = this;

                if ( $(params.event.target).hasClass("vgt-checkbox-col") || $(params.event.target).hasClass("glyphicon glyphicon-eye-open")) {
                   return;
                }

                if ( self.reqeustSent == 1 ) {
                   return;
                }

                //if data already available than remove it
                if ( $(params.event.target.closest('.clickable').nextSibling).hasClass("invoiceDetails")) {
                    $(params.event.target.closest('.clickable').nextSibling).remove();
                    return;
                }

                //generate html
                var html = '<tr class="invoiceDetails"><td colspan="9"><table aria-describedby="table" class="table">';
                html += '<tr><th>Year</th><th>Month</th><th>Customer</th><th>BillBack Amount</th><th>Allowance</th><th>Amortized Amount</th><th>Effective Date</th><th>Expiry Date</th><th>Description</th><th>Action</th></tr>';

                var fields = {
                    hvut_schedule_id:params.row.id,
                };
                self.reqeustSent = 1;

                // self.loading = true;

                $.ajax({
                    url: process.env.ROOT_API + "/processed-hvut-schedule/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {

                        self.reqeustSent = 0;
                        self.loading = false;
                        if ( data.code == 200 ) {

                            //check data records
                            if ( data.content.row.length > 0 ) {

                                for ( var j=0; j<data.content.row.length; j++ ) {
                                    if ( data.content.row[j].invoiceFlag == 1 ) {

                                        if ( data.content.row[j].invoice_id != "-" ) {
                                            html += '<tr><td>'+data.content.row[j].year+'</td><td>'+data.content.row[j].month+'</td><td>'+data.content.row[j].customer+'</td><td>'+data.content.row[j].amount+'</td><td>'+ data.content.row[j].allowance +'</td><td>'+data.content.row[j].amortized_amount+'</td><td>'+data.content.row[j].from_date+'</td><td>' +data.content.row[j].to_date+ '</td><td>' + data.content.row[j].description + '</td><td><a class="color-blue show-invoice-link" title="View Invoice" data-row-invoice-id="'+ data.content.row[j].invoice_id +'" href="javascript:void(0)">'+ data.content.row[j].invoice_number  +'</a></td></tr>';
                                        }else{
                                            html += '<tr><td>'+data.content.row[j].year+'</td><td>'+data.content.row[j].month+'</td><td>'+data.content.row[j].customer+'</td><td>'+data.content.row[j].amount+'</td><td>'+ data.content.row[j].allowance + '</td><td>'+data.content.row[j].amortized_amount+'</td><td>'+data.content.row[j].from_date+'</td><td>' +data.content.row[j].to_date+ '</td><td>' + data.content.row[j].description +'</td><td><a class="btn btn-success waves-effect generate-invoice-link" data-row-id="'+ data.content.row[j].id +'" href="javascript:void(0)">Generate Invoice</a></td></tr>';
                                        }

                                    }else{
                                        html += '<tr><td>'+data.content.row[j].year+'</td><td>'+data.content.row[j].month+'</td><td>'+data.content.row[j].customer+'</td><td>'+data.content.row[j].amount+ '</td><td>'+ data.content.row[j].allowance + '</td><td>'+data.content.row[j].amortized_amount+'</td><td>'+data.content.row[j].from_date+'</td><td>' +data.content.row[j].to_date+'</td><td>' + data.content.row[j].description + '</td><td>-</td></tr>';
                                    }
                                }

                            } else {

                                html += '<tr><td colspan="9">No record found.</td></tr>';
                            }

                            html += '</table></td></tr>';
                            $(html).insertAfter(params.event.target.closest('.clickable'));
                        }else{
                            html += '<tr><td colspan="9">No record found.</td></tr>';
                            html += '</table></td></tr>';
                            $(html).insertAfter(params.event.target.closest('.clickable'));
                        }
                    },
                    error: function (jqXHR, exception) {

                        self.reqeustSent = 0;

                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'process-hvut-scdu-on-row')
                    }
                });
            },
            getLastDateofmonth:function(){
                var self = this;

                var date = new Date();
                // var newdate = new Date();
                var arr = [];
                var monthCount = 0;
                var currentDate = new Date();
                var currentMonth = currentDate.getMonth() + 1;
                var currentYear = currentDate.getFullYear();
                if (currentMonth < 7) {
                    var previousYear = moment().subtract(1, 'years').format('Y');
                    var fhutStartDate = new Date(previousYear,6,1);
                    monthCount = self.monthsDiff(fhutStartDate,date);
                }else{
                    var nextYear = moment().add(1, 'years').format('Y');
                    var fhutStartDate = new Date(currentYear,6,1);
                    monthCount = self.monthsDiff(fhutStartDate,date);
                }
                // for(var i = monthCount; i >= 0;i--){
                    /*if (i == 0){
                        if (moment(date).format('MM/DD/YYYY') == moment(date).endOf('month').format('MM/DD/YYYY')){
                            var momentDate = moment(date).subtract(i, 'months').format('MM/DD/YYYY');
                            arr.push(moment(momentDate).endOf('month').format('MM/DD/YYYY'));

                        }
                    }else{
                        var momentDate = moment(date).subtract(i, 'months').format('MM/DD/YYYY');
                        arr.push(moment(momentDate).endOf('month').format('MM/DD/YYYY'));

                    }*/
                    // arr.push(moment(date).subtract(i, 'months').format('MM/DD/YYYY'));
                    // var momentDate = moment(date).subtract(i, 'months').format('MM/DD/YYYY');
                    // var currentMonthEndDate = moment(date).endOf('month').format('MM/DD/YYYY');
                    // if (Date.parse(moment(momentDate).endOf('month').format('MM/DD/YYYY')) <= Date.parse(currentMonthEndDate)) {
                    //     arr.push(moment(momentDate).endOf('month').format('MM/DD/YYYY'));//Date less than or Equal Current Month End Date
                    // }
                // }
                for (var i = 0; i < 6; i++) {
                    var monthAgo = moment().subtract(i, 'months');
                    var monthEndDate = monthAgo.endOf('month').format('MM/DD/YYYY');
                    arr.push(monthEndDate);
                }
                arr.sort(function(a, b) {
                    return moment(a, 'MM/DD/YYYY').toDate() - moment(b, 'MM/DD/YYYY').toDate();
                });
                // for(var j = 0; j <= 3;j++){
                //     var momentDate = moment(newdate).add(j, 'months').format('MM/DD/YYYY');
                //     arr.push(moment(momentDate).endOf('month').format('MM/DD/YYYY'));
                // }
                self.dateArr = arr;
                console.log(self.dateArr);
            },
            monthsDiff(d1, d2) {
                let date1 = new Date(d1);
                let date2 = new Date(d2);
                let years = date2.getFullYear() - date1.getFullYear();
                let months =(years * 12) + (date2.getMonth() - date1.getMonth()) ;
                return months;
            },
            checkBatchStatus:function(){
                var self =  this;
                this.$sse(process.env.ROOT_API + '/check/batch-status/'+self.fhutBatchId, { format: 'json' }) // or { format: 'plain' }
                .then(sse => {
                    // Store SSE object at a higher scope
                    msgServer = sse;

                    // Listen for messages without a specified event
                    sse.subscribe('', data => {
                        if ( data.status == "1") {
                            self.fhutProcessBatch = false;
                            self.loadList();
                            sse.close();
                        }else if (data.status == "2") {
                            self.fhutProcessBatch = false;
                            self.batchError = true;
                            self.batchErrorMsg = data.message;
                            sse.close();
                        }
                    });

                })
                .catch(err => {
                    // When this error is caught, it means the initial connection to the
                    // events server failed.  No automatic attempts to reconnect will be made.
                    console.error('Failed to connect to server', err);
                });
            },

            openInvoiceLink(element){
              element.preventDefault();
              var id = element.dataset.rowInvoiceId;
              if ( id != undefined && id != null ) {
                  // self.$router.push({ name: 'HvutInvoice', params:{id: id}});
                  let routeData = this.$router.resolve({ name:"HvutInvoice",params:{ id: id}});
                  window.open(routeData.href,"_blank");
              }
            },

            generateInvoiceLink(element){

            },

            getAllFHUTList: function(){

                var self = this;
                $('#divTabMenu button').removeClass("active");
                $("#getallFHUTList").addClass("active");
                self.$refs.assetHVUTList.clearSelectAll();
                EventBus.$emit('clear-all-flags', false);
                self.all = 'active';
                localStorage.setItem('fhut_schedule_list_tab', 'all_tab');
                self.entry = '';
                self.processed = '';
                self.expired = '';
                self.selectedStatus = "";
                self.$nextTick(() => {
                    // Add the component back in
                    self.selectedStatus = "all";
                    self.$refs.assetHVUTList.onColumnFilter('cancel');
                });
            },

            getEntryFHUTList: function(){

                var self = this;
                $('#divTabMenu button').removeClass("active");
                $("#getentryFHUTList").addClass("active");
                self.$refs.assetHVUTList.clearSelectAll();
                EventBus.$emit('clear-all-flags', false);
                self.entry = 'active';
                localStorage.setItem('fhut_schedule_list_tab', 'entry_tab');
                self.all = '';
                self.processed = '';
                self.expired = '';
                self.selectedStatus = "";
                self.$nextTick(() => {
                    // Add the component back in
                    self.selectedStatus = "entry";
                    self.$refs.assetHVUTList.onColumnFilter('cancel');
                });
            },

            getProcessedFHUTList: function(){

                var self = this;
                $('#divTabMenu button').removeClass("active");
                $("#getprocessedFHUTList").addClass("active");
                self.$refs.assetHVUTList.clearSelectAll();
                EventBus.$emit('clear-all-flags', false);
                self.processed = 'active';
                localStorage.setItem('fhut_schedule_list_tab', 'processed_tab');
                self.entry = '';
                self.expired = '';
                self.all = '';
                self.selectedStatus = "";
                self.$nextTick(() => {
                    // Add the component back in
                    self.selectedStatus = "processed";
                    self.$refs.assetHVUTList.onColumnFilter('cancel');
                });
            },

            getExpiredFHUTList: function(){

              var self = this;
              $('#divTabMenu button').removeClass("active");
              $("#getexpiredFHUTList").addClass("active");
              self.$refs.assetHVUTList.clearSelectAll();
              EventBus.$emit('clear-all-flags', false);
              self.expired = 'active';
              localStorage.setItem('fhut_schedule_list_tab', 'expired_tab');
              self.entry = '';
              self.all = '';
              self.processed = '';
              self.selectedStatus = "";
              self.$nextTick(() => {
                  // Add the component back in
                  self.selectedStatus = "expired";
                  self.$refs.assetHVUTList.onColumnFilter('cancel');
              });
            },
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/hvut/HVUTScheduleList.vue